// Default React, useState and Material Components
import React, { useState } from "react";
import { Button, Breadcrumbs, CircularProgress, Grid, IconButton, InputAdornment, TextField, Typography, Box, } from "@mui/material";
import { Link } from 'react-router-dom';
// Importing Custom Services
import ApiService from "../../../Services/ApiService";
import ErroHandling from "../../../Services/ErrorHandling";
import GetMenuService from "../../../Services/GetMenuService";

// Importing Custom Components
import SideDrawer from "../../../UIComponent/Drawer";
import DataTable from "../../../UIComponent/DataTable";
import BaseLayout from "../../../UIComponent/BaseLayout";
import AlertDialog from "../../../UIComponent/AlertDialog";
import { toasterError, toasterSuccess } from "../../../UIComponent/Toaster";

// Importing Add & Edit Components
import AddEditChangeType from "./AddEditChangeType";

// Import Fluent UI Icons
import { AddIcon, ChevronRightSmallIcon, ClearIcon, SearchIcon } from "@fluentui/react-icons-mdl2";

// Importing useStyles
import useStyles from "../ManageData.styles";

const ChangeTypes = (props) => {

    // Declaration of States and Component Variables Start Here
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [reload, setReload] = React.useState(false);
    const [formData, setFormData] = React.useState([]);
    const [selected, SetSelected] = React.useState([]);
    const [state, setState] = useState({ right: false });
    const [totalCount, setTotalCount] = React.useState(0);
    const [isLoading, setLoading] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState();
    const [crudState, setCrudState] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [openDelete, setOpenDelete] = React.useState(false);
    const [allChangeTypes, setChangeTypes] = React.useState([]);
    const [isAllSelected, setIsSelected] = React.useState(false);
    const [deleteBtnLoadinng, setDeleteBtnLoadinng] = React.useState(false);
    const [deleteStockExchanges, setDeleteStockExchanges] = React.useState(null);
    const [addStockExchangeDrawer, setAddStockExchangeDrawer] = React.useState(true);
    const [sorting, setSorting] = React.useState({ sortBy: "", isAscending: false });
    const [access, setAccess] = React.useState({ allowEdit: false, allowDelete: false, allowView: false });
    const [menuPermission, setMenuPermission] = React.useState({ allowView: true, allowEdit: true, allowDelete: true, });
    // Declaration of States and Component Variables End Here

    // Declaration of React Hooks Start Here
    React.useEffect(() => {
        GetMenuService(47, function (err, res) {
            if (res) {
                setAccess(res.data)
            } else {
                toasterError(err)
            }
        })
    }, [])
    React.useEffect(() => {
        if (searchValue == "" || searchValue == null || searchValue == undefined) {
            getAllChangeType();
        }
        if (searchValue && reload) { searchStockExchange(searchValue); }
    }, [page, reload, rowsPerPage])
    React.useEffect(() => {
        if (searchValue == "" || searchValue == null || searchValue == undefined) {
            getAllChangeType();
        }
        if (searchValue) { searchStockExchange(searchValue); }
    }, [sorting])
    // Declaration of React Hooks End Here

    // Assigning Columns and UI Props
    const columns = [
        { id: "Id", label: "Id", type: "Highlight" },
        { id: "changeType", label: "Change Type", minWidth: 350, width: '15%', sorting: true },
        { id: "description", label: "Description", minWidth: 400, width: 'auto', sorting: true, truncate: 90, tooltipWithTruncate: true },
    ];

    // Function for Handle KeyUp
    const handleKeyUp = (event) => {
        if ((event.keyCode === 8 || event.which === 8) && event.target.nodeName !== "BUTTON") {
            if (searchValue.length === 0) { getAllChangeType(); }
        }
        if ((event.keyCode === 13 || event.which === 13) && event.target.nodeName !== "BUTTON") {
            setTotalCount(0);
            setPage(0);
            searchStockExchange(event.target.value);
        }
    };

    // Function for Sorting
    const changeSortColumnNameFormat = (columnName) => {
        let newColumnName = "";
        if (columnName !== "" && columnName !== null) {
            newColumnName = columnName[0].toUpperCase() + columnName.slice(1, columnName.length)
        }
        return newColumnName;
    }

    // Function for Open Delete Panel
    const toggleDrawer = (open, mode) => (event, item) => {
        if (mode === "Delete") {
            setDeleteStockExchanges(item);
            setOpenDelete(true);
        } else {
            setFormData(item);
            setState({ ...state, right: open, formData: item });
            setCrudState(mode);
        }
    };

   // Function to get all change types
    const getAllChangeType = () => {
      // Set loading to true  
        setLoading(true);
        // Create an array of parameters
        let prt = [`pageNumber=${page + 1}`, `pageSize=${rowsPerPage}`];
        // Call the ApiService search method
        ApiService.search("managedata/GetChangeTypeDetails?",
            {
             // Set the sorting column and order    
                sortColumn: changeSortColumnNameFormat(sorting.sortBy),
                isAscending: sorting.isAscending
            }, prt
        ).then((res) => {
          // If response status is 200, set the changeTypes and totalCount  
            if (res.status === 200) {
                setChangeTypes(res.data.data);
                setTotalCount(res.data.totalCount);
                setLoading(false);
            } else {
           // Else call the toasterError function     
                toasterError(`${res.data}`);
                setLoading(false);
            }
        })
            .catch((err) => {
               // Catch any errors and call the ErroHandling function 
                setLoading(false);
                ErroHandling(err, function (res) {
                    toasterError(res)
                })
            });
    }

    // Function for Global Search
    const globalSearch = (value) => { setSearchValue(value); }

   // This function is used to search stock exchange based on filter value 
    const searchStockExchange = (filterValue) => {
      // Set loading to true while the API call is in progress  
        setLoading(true);
       // Create an array of parameters for the API call 
        let prt = [`pageNumber=${page + 1}`, `pageSize=${rowsPerPage}`];
        // Make an API call to get the change type details 
        ApiService.search(
            "managedata/GetChangeTypeDetails?",
            {
                // Encode the search text
                searchText: encodeURIComponent(filterValue),
                // Format the sort column name
                sortColumn: changeSortColumnNameFormat(sorting.sortBy),
                // Set the sorting order
                isAscending: sorting.isAscending
            }, prt)
            .then((res) => {
                if (res.status === 200) {
                    // Set the change types and loading status
                    setChangeTypes(res.data.data);
                    setLoading(false);
                    setTotalCount(res.data.totalCount);
                } else {
                   // Show error message 
                    toasterError(`${res.data}`);
                    setLoading(false);
                }
            })
            .catch((err) => {
               // Set loading to false and handle errors 
                setLoading(false);
                ErroHandling(err, function (res) {
                    toasterError(res)
                })
            });
    }

   // Function to delete a change type
    const deleteChangeType = () => {
      // Set loading state of delete button to true  
        setDeleteBtnLoadinng(true);
        // Store the data to be deleted in a variable
        let data = deleteStockExchanges;
         // Set active status to false
        data.active = false;
        // Make an API call to delete the change type
        ApiService.create(`managedata/DeleteChangeType?changeTypeId=${data.id}`)
            .then((res) => {
                // If API call is successful, show success message and update the change type list
                if (res.status === 200) {
                    toasterSuccess("Change type deleted successfully!");
                    getAllChangeType();
                    setDeleteBtnLoadinng(false);
                    setOpenDelete(false);
                } else {
                    // If API call fails, show error message
                    toasterError("Something went wrong");
                    setOpenDelete(false);
                    setDeleteBtnLoadinng(false);
                }
            })
            .catch((err) => {
             // If there is an error, set loading state to false and show error message    
                setOpenDelete(false);
                setDeleteBtnLoadinng(false);
                ErroHandling(err, function (res) {
                    toasterError(res)
                })
            });
    }
    return (

        // Page Layout Start Here
        <Box>
            <Grid container maxWidth justifyContent="right" alignItems="center">

                {/* Breadcrumbs Menu Start Here */}
                <Grid item xs={12} sm={12} md={6} className="page-title">
                    <h2>Change Types</h2>
                    <Breadcrumbs
                        separator={<ChevronRightSmallIcon className={classes.breadCrumbsIcon} />} aria-label="breadcrumb" className="custom-breadcrumb">
                        <Link underline="hover" color="inherit" to= {{ pathname: "/app/ownership-changes/source-management" }}>Home</Link>
                        <Link underline="hover" color="inherit" to= {{ pathname: "/app/commodity" }}>Manage Data</Link>
                        <Typography>Change Types</Typography>
                    </Breadcrumbs>
                </Grid>
                {/* Breadcrumbs Menu End Here */}

                {/* Main Buttons Start Here */}
                <Grid item xs={12} sm={12} md={6}>
                    <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
                        <Grid item xs={"auto"}>
                            {(access.allowEdit) ? <>
                                <Button onClick={toggleDrawer(true, "Add")} variant="contained" color="accent2" startIcon={<AddIcon style={{ fontSize: "16px" }} />}>
                                    Add Change Type
                                </Button></> : null}
                        </Grid>
                    </Grid>
                </Grid>
                {/* Main Buttons End Here */}

                {/* Baselayout Start Here */}
                <Grid item xs={12}>
                    <BaseLayout>
                        <Box className={classes.addBorder}>

                            {/* Search Option and Total Count Start Here */}
                            <Grid item xs={12} className={classes.tableTopPart}>
                                <Grid container alignItems="center" justifyContent="left" spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            id="input-with-icon-textfield"
                                            className={classes.searchByKeyword}
                                            value={searchValue}
                                            placeholder="Search by Keyword"
                                            onKeyUp={handleKeyUp}
                                            onChange={(e) => globalSearch(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon className={classes.searchIcon} />
                                                    </InputAdornment>
                                                ),
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        {searchValue ? (<IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() => {
                                                                setSearchValue("");
                                                                // setReload(true);
                                                                getAllChangeType();
                                                            }}
                                                        >
                                                            <ClearIcon style={{ fontSize: 10 }} />
                                                        </IconButton>) : ("")}
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} textAlign="right">
                                        <Typography variant="subtitle2">
                                            Total Records: <span className={classes.totalRecord}>{totalCount}</span>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* Search Option and Total Count End Here */}

                            {/* Stock Exchange Table /> */}
                            <Grid item xs={12}>
                                <DataTable
                                    className={classes.removeBorder}
                                    loading={isLoading}
                                    rows={allChangeTypes ? allChangeTypes : []}
                                    columns={columns}
                                    page={page}
                                    setPage={(data) => { setPage(data); setReload(true); }}
                                    rowsPerPage={rowsPerPage}
                                    setRowsPerPage={(data) => {
                                        setRowsPerPage(data);
                                        setReload(true);
                                    }}
                                    totalCount={totalCount}
                                    isAllSelected={isAllSelected}
                                    setIsSelected={setIsSelected}
                                    selected={selected}
                                    setSelected={SetSelected}
                                    sorting={sorting}
                                    setSorting={(e) => {
                                        setSorting(e);
                                    }}
                                    isActionButton={{
                                        ...(access.allowView && {
                                            view: toggleDrawer(true, "View"),
                                        }),
                                        ...(access.allowEdit && { edit: toggleDrawer(true, "Edit"), }),
                                        ...(access.allowDelete && { delete: toggleDrawer(true, "Delete"), }),
                                    }}
                                />
                            </Grid>
                        </Box>
                    </BaseLayout>
                </Grid>
            </Grid>
            <SideDrawer
                formComp={
                    <AddEditChangeType
                        state={state}
                        setState={setState}
                        crudState={crudState}
                        formData={formData}
                        setFormData={setFormData}
                        variableId={null}
                        hideSideDrawer={() => {
                            setState({ right: false });
                            setSearchValue("");
                            setReload(!reload);
                        }}
                        addStockExchangeDrawer={addStockExchangeDrawer}
                    />
                }
                state={state}
                setState={setState}
            />
            {openDelete ? (
                <AlertDialog
                    open={openDelete}
                    title={"Confirmation"}
                    maxWidth={"sm"}
                    description={`Are you sure you want to delete?`}
                    action={
                        <>
                            <div className={classes.alertDialogbtn}>
                                <Button onClick={() => setOpenDelete(false)} style={{ marginRight: "15px" }}>No</Button>
                                {deleteBtnLoadinng ? (
                                    <CircularProgress />
                                ) : (
                                    <Button onClick={() => deleteChangeType()} color="secondary">
                                        Yes
                                    </Button>
                                )}
                            </div>
                        </>
                    }
                />
            ) : null}
        </Box>
    );
};

export default ChangeTypes;